<mat-stepper  [orientation]="isHandset ? 'vertical' : 'horizontal'" linear #stepper>

  <!-- Step 1: Osnovni podaci o korisniku -->
  <mat-step [stepControl]="useryBasicInfoForm">
    <ng-template matStepLabel>I. Osnovni podaci o korisniku</ng-template>
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title><h5 class="mb-0">I. Osnovni podaci o korisniku</h5></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form [formGroup]="useryBasicInfoForm">
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Korisničko ime / E-mail</mat-label>
              <input matInput formControlName="userName" />
            </mat-form-field>
          </div>
          @if (!isUpdating) {
            <div class="mb-25">
              <mat-form-field class="full-width">
                <mat-label>Unesite lozinku</mat-label>
                <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password">
                <button mat-icon-button matSuffix (click)="hidePassword = !hidePassword" tabindex="-1">
                  <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
              </mat-form-field>
            </div>
          }
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Ime</mat-label>
              <input matInput formControlName="firstName" />
            </mat-form-field>
          </div>
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Prezime</mat-label>
              <input matInput formControlName="lastName" />
            </mat-form-field>
          </div>
          <div class="mb-25">
            <mat-checkbox formControlName="isActive">Aktivan</mat-checkbox>
          </div>
          <div class="mb-25">
            <mat-form-field class="full-width">
              <mat-label>Korisničke uloge</mat-label>
              <mat-select formControlName="roles" multiple>
                @for (role of roles; track role) {
                  <mat-option [value]="role.id">
                    {{ role.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <button mat-flat-button matStepperNext class="daxa" [disabled]="useryBasicInfoForm.invalid">Dalje</button>
        </form>
      </mat-card-content>
    </mat-card>
  </mat-step>

  <!-- Step 2 (if updating): Potvrda -->
  <mat-step>
    <ng-template matStepLabel>Potvrda</ng-template>
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title><h5 class="mb-0">Ažuriranje korisničkih podataka</h5></mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div>
          <button mat-flat-button matStepperPrevious class="mr-15">Nazad</button>
          <button mat-flat-button color="primary" (click)="onSubmit()">Spremi</button>
        </div>
      </mat-card-content>
    </mat-card>
  </mat-step>

</mat-stepper>